import React from "react";
import { useLanguageContent } from "../Components/LangueContentLoader";
import hero from "../Images/hero.gif";
import MouseTrail from "../Components/MouseTrail";
import { motion } from "framer-motion";

export default function Home() {
  const content = useLanguageContent();

  return (
    <motion.main
      id="Home"
      className="home-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      <div className="home-banner">
        <MouseTrail />

        <div className="home-desc">
          <div className="descBox">
            <h2 className="homeTitle">
              {content.homeTitle}
              <span className="homeName">{content.name}</span>
            </h2>
            <h1 className="homeTitle">{content.welcome_message}</h1>

            <p className="homeText">
              {content.homeTxt}
              <br />
              {content.homeTxt2}
            </p>
          </div>
        </div>

        <div className="hero-box">
          <div className="hero-container">
            <div className="glitch-image-container">
              <img src={hero} alt="hero" className="glitch-img" />
            </div>
          </div>
        </div>
      </div>

      <div className="homeResume">
        <h2 className="resumeTitle">{content.resumeTitle}</h2>

        <div className="single-exp">
          <div className="yearSide">
            <p>2024 - 2025</p>
          </div>
          <div className="expSide">
            <div className="exp-content">
              <h4 className="exp-title">
                {content.degree1} <br />
              </h4>
              <h5 className="single-post-h5">Chez Ugo & Léa (Dreux, 28100)</h5>
              <br />
              <p className="exp-text">{content.homeTxt4}</p>
              <span className="tag">Google Ads</span>
              <span className="tag">WordPress</span>
              <span className="tag">GA4</span>
              <span className="tag">Blog</span>
              <span className="tag">Illustrator</span>
              <span className="tag">Canva</span>
              <span className="tag">Excel</span>
              <span className="tag">Word</span>
              <span className="tag">CapCut Pro</span>
              <span className="tag">Odoo</span>
            </div>
          </div>
        </div>

        <div className="single-exp">
          <div className="yearSide">
            <p>2021 - 2024</p>
          </div>
          <div className="expSide">
            <div className="exp-content">
              <h4 className="exp-title">{content.careerChangeTitle}</h4>
              <h5 className="single-post-h5">
                {" "}
                {content.careerChangeLocations}
              </h5>
              <br />
              <div className="exp-text">{content.careerChangeDescription}</div>
              <span className="tag">{content.tag10}</span>
              <span className="tag">{content.tag11}</span>
              <span className="tag">{content.tag12}</span>
              <span className="tag">{content.tag13}</span>
              <span className="tag">{content.tag14}</span>
              <span className="tag">{content.tag15}</span>
              <span className="tag">{content.tag16}</span>
              <span className="tag">{content.tag17}</span>
              <span className="tag">{content.tag18}</span>
              <span className="tag">{content.tag19}</span>
              <span className="tag">{content.tag21}</span>
              <span className="tag">{content.tag22}</span>
              <span className="tag">{content.tag23}</span>
            </div>
          </div>
        </div>

        <div className="single-exp">
          <div className="yearSide">
            <p>2009 - 2021</p>
          </div>
          <div className="expSide">
            <div className="exp-content">
              <p className="exp-title">
                {content.restauration_title} Restauration - 12 ans <br />
              </p>
              <div className="exp-text">{content.homeTxt3}</div>
              <span className="tag">{content.tag1}</span>
              <span className="tag">{content.tag2}</span>
              <span className="tag">{content.tag3}</span>
              <span className="tag">{content.tag4}</span>
              <span className="tag">{content.tag5}</span>
              <span className="tag">{content.tag6}</span>
              <span className="tag">{content.tag7}</span>
              <span className="tag">{content.tag8}</span>
              <span className="tag">{content.tag9}</span>
            </div>
          </div>
        </div>
      </div>
    </motion.main>
  );
}
